import { ITopLevelProps, ViewModes } from "../support/registration_form_component"
import { AttachmentField } from "../support/attachment_field"
import { WelcomeStep } from "../form/welcome_step"
import { RegistrationGeneralInfo } from "../form/general_info"
import { RegistrationContactInfo } from "../form/contact_info"
import {
  RegistrationClaims,
  TopLevelCommentsField,
} from "../form/claims"
import { RegistrationReviewSubmit } from "../form/review_submit"
import { RegistrationThankYou } from "../form/thank_you"
import { QualificationStep } from "../form/qualification_step"

export function OHCA(props: ITopLevelProps) {
  const {
    context,
    welcomeStepProps,
    qualificationStepProps,
    parentCompanyNameOptions,
  } = props

  const {
    config,
    client,
    current_step,
    view_mode,
  } = context

  const downloadableView = view_mode === ViewModes.DOWNLOADABLE
  const requiresQualification = context.client.requires_qualification

  return (
    <div>
      <WelcomeStep
        {...context}
        {...welcomeStepProps}
        active={downloadableView || current_step === 0}
      />

      <RegistrationGeneralInfo
        {...context}
        active={downloadableView || current_step === 1}
        dental={false}
        showEstimates={false}
        parentCompanyNameOptions={parentCompanyNameOptions}
      />

      { requiresQualification &&
          <QualificationStep
            {...context}
            {...qualificationStepProps}
            active={downloadableView || current_step === 2}
          />
      }

      <RegistrationContactInfo
        {...context}
        active={downloadableView || current_step === (requiresQualification ? 3 : 2)}
        contactTypes={config.contactTypes}
      />

      <RegistrationClaims
        {...context}
        active={downloadableView || current_step === (requiresQualification ? 4 : 3)}
      >
        <TopLevelCommentsField {...context} />
        {client.has_registration_attachment && <AttachmentField {...context} required={true} />}
      </RegistrationClaims>

      <RegistrationReviewSubmit
        {...context}
        active={downloadableView || current_step === (requiresQualification ? 5 : 4)}
        suppress_attachment_download_warning={true}
      />

      <RegistrationThankYou
        {...context}
        active={downloadableView || current_step === (requiresQualification ? 6 : 5)}
      />
    </div>
  )
}
